import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import { Alert as MUIAlert, AlertType } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

interface Props {
  className?: string;
  message?: React.ReactNode;
  onClose?: () => void;
  variant?: AlertType;
}

export const Alert = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { onClose, ...otherProps } = props;
  const { T } = useIntl();

  return (
    <MUIAlert
      {...otherProps}
      ref={ref}
      action={[
        <Track name="Clicked Close alert bar" type="button" key="close">
          <IconButton
            data-test-locator="Alert Close Icon"
            aria-label={T('Close')}
            color="inherit"
            onClick={onClose}
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </Track>,
      ]}
    />
  );
});
